"use client";

import { useRouter } from "next/navigation";
import { Button } from "@shared/src/components/ui/button";
import { cn } from "@shared/src/utils/cn";
import { ButtonProps } from "@shared/src/components/ui/button";
import { forwardRef, useState } from "react";
import { useModalStore } from "@shared/src/stores/useModalStore";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { useDisconnect } from "wagmi";
import { SignInWithBase } from "@web/app/(no-sidebar)/signinwithbase";

type SignInButtonProps = Omit<ButtonProps, "onClick">;

export const SignInButton = forwardRef<HTMLButtonElement, SignInButtonProps>(({ className, ...props }, ref) => {
  const setModalOpen = useAuthStore(state => state.setModalOpen);

  const handleClick = () => {
    setModalOpen(true);
  };

  return (
    <>
      <Button
        ref={ref}
        variant="primary"
        size="cta"
        radius="full"
        onClick={handleClick}
        className={cn(className)}
        {...props}
      >
        Sign In
      </Button>
    </>
  );
});

SignInButton.displayName = "SignInButton";
